import { Box, CircularProgress } from "@podcastsoundboard/ps-lib/ui"
const Fallback = () => {
  return (
    <main style={{ padding: "1rem" }}>
      <Box className="flex justify-center">
        <CircularProgress />
      </Box>
    </main>
  )
}

export default Fallback
